import React, { Component } from "react";
import PropTypes from "prop-types";
import { getApiPath } from "../data/api";
import { getModel, updateModel, setAuthToken } from "../data/Model";
import Loader from "../generic/Loading";
import logo from "../images/logo.svg";
import Input from "../generic/Input";
import { Link } from "react-router-dom";

class LoginScreen extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      email: "",
      password: "",
      passwordChanged: getModel().passwordChanged,
      loading: false,
      errors: []
    };

    updateModel(model => {
      model.passwordChanged = false;
      return model;
    });
  }

  login = () => {
    this.setState({
      loading: true
    });
    fetch(getApiPath("/authentication/login"), {
      method: "POST",
      body: JSON.stringify({
        email: this.state.email,
        password: this.state.password
      }),
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      }
    })
      .then(res => res.json())
      .then(data => {
        if (data.auth_token) {
          setAuthToken(data.auth_token);
        } else {
          this.setState({
            errors: [this.context.gettext("welcome.screen.error.wrong_info")]
          });
        }
        this.setState({
          loading: false
        });
      });
  };

  render() {
    return (
      <div id="welcome-content">
        <div
          style={{
            opacity: this.state.loading ? 1 : 0,
            transform: this.state.loading
              ? "translateY(0px)"
              : "translateY(50px)"
          }}
          className="loading"
        >
          <Loader />
        </div>
        <div
          style={{
            opacity: this.state.loading ? 0 : 1,
            transform: this.state.loading
              ? "translateY(-50px)"
              : "translateY(0px)"
          }}
          className="auth-box"
        >
          <img src={logo} className="logo" alt="logo" />
          {this.state.passwordChanged && (
            <h1 className="info-text">
              Your password was saved. Please log in
            </h1>
          )}
          {!this.state.passwordChanged && (
            <h1 className="info-text">Welcome. Please log in</h1>
          )}
          {this.state.errors.map(error => (
            <div className="warning">{error}</div>
          ))}
          <Input
            onKeyDown={e => {
              if (e.key === "Enter") this.login();
            }}
            onChange={e => {
              this.setState({
                email: e.target.value
              });
            }}
            className="inp"
            type="text"
            value={this.state.email}
            placeholder={this.context.gettext(
              "welcome.screen.placeholder.email"
            )}
          />
          <Input
            onKeyDown={e => {
              if (e.key === "Enter") this.login();
            }}
            onChange={e => {
              this.setState({
                password: e.target.value
              });
            }}
            className="inp"
            type="password"
            value={this.state.password}
            placeholder={this.context.gettext(
              "welcome.screen.placeholder.password"
            )}
          />
          <div className="d-flex">
            <Link to={"/forgot-password"} className="auth-link">
              Forgot your password?
            </Link>
            <button
              className="btn full-width auth-btn"
              onClick={this.login}
              disabled={
                !(this.state.email && this.state.password) || this.state.loading
              }
            >
              {this.context.gettext("welcome.screen.login_button")}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

LoginScreen.contextTypes = {
  gettext: PropTypes.func.isRequired,
};

export default LoginScreen;
